import { productVersionFromFirestore } from '@parallel-fluidics/shared/models/products';
import {
  doc,
  getDoc,
  getFirestore,
} from 'firebase/firestore';

export default async function fetchProductVersion(productDocId, versionId) {
  const snapshot = await getDoc(doc(getFirestore(), 'products', productDocId, 'versions', versionId));

  if (!snapshot.exists()) {
    throw new Error(`Product version not found: ${productDocId}/${versionId}`);
  }

  return productVersionFromFirestore(snapshot);
}
